// extracted by mini-css-extract-plugin
export default {"content":"column_content__ITnAc","column":"column_column__mQp8U","default":"column_default__VVf8p","changing":"column_changing__bPGb+","modified":"column_modified__fZUQu"};